import brand from '@configs/brand'
import { useSkin } from '@src/utility/hooks/useSkin'

const SpinnerComponent = () => {
  const [skin] = useSkin()
  const isDarkMode = skin === 'dark'
  const logoSrc = isDarkMode
    ? brand.assets.logoMonoLight || brand.assets.logo
    : brand.assets.logo

  return (
    <div className='fallback-spinner vh-100'>
      <img
        className='fallback-logo'
        src={logoSrc}
        alt='logo'
      />
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
